import React, { useState, useEffect } from 'react';
import { Form, FormGroup, Button, Label, Input } from 'reactstrap';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Login.css';
import { Link, useNavigate } from 'react-router-dom';
import BaseUrl from '../../base-api';

const Login = () => {
  const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = useState('');
  const [onetimepassword, setOneTimePassword] = useState('');
  const [errors, setErrors] = useState({ mobileNumber: '', otp: '' });
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [mobileField, setMobileField] = useState(false);
  const [timer, setTimer] = useState(0);
  const resendDelay = 60; // seconds

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer(prevTimer => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const sendOtp = async () => {
    if (validateMobileNumber()) {
      try {
        const response = await axios.post(`${BaseUrl}/auth/authenticateUser`, { mobileNumber });
        if (response.status === 200) {
          toast.success(response.data.message);
          setIsOtpSent(true);
          setTimer(resendDelay);
          setMobileField(true);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error('Somethig went wrong. Kindly check again later');
      }
    }
  };

  const validateMobileNumber = () => {
    const errorsCopy = { ...errors };
    const mobilePattern = /^[0-9]{10}$/;
    if (mobileNumber.match(mobilePattern)) {
      errorsCopy.mobileNumber = '';
    } else {
      errorsCopy.mobileNumber = 'Please enter a valid 10-digit mobile number';
    }
    setErrors(errorsCopy);
    return mobileNumber.match(mobilePattern);
  };

  const validateOtp = () => {
    const errorsCopy = { ...errors };
    const otpPattern = /^[0-9]{6}$/;
    if (onetimepassword.match(otpPattern)) {
      errorsCopy.otp = '';
    } else {
      errorsCopy.otp = 'Please enter a valid 6-digit OTP';
    }
    setErrors(errorsCopy);
    return onetimepassword.match(otpPattern);
  };

  const verifyOtp = async () => {
    // if (validateOtp()) {
    try {
      const response = await axios.post(`${BaseUrl}/auth/authorizeUser`, { mobileNumber, onetimepassword });
      if (response.status === 200) {
        localStorage.setItem('$3ingT0k3n', response.data.token);
        toast.success(response.data.message);
        switch (response.data.defaultScreen) {
          case "dashboard":
            navigate("/SideBar/dashboard")
            break;
          case "courses":
            navigate("/SideBar/my-courses")
            break;
          case "admissions":
            navigate("/SideBar/admissions")
            break;
        }
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error('An error occurred while verifying OTP.');
    }
    // }
  };

  const handleResendOtp = () => {
    setOneTimePassword('');
    sendOtp();

  };

  return (
    <>
      <div className="row justify-content-center" style={{ backgroundColor: "white", padding: "60px 22px 45px 22px" }}>
        <div className='col-md-4 ' style={{ backgroundColor: 'white', border: '1px solid #8d7b7b8a', padding: "4%", boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)', borderRadius: '6px' }}>
          {/* <div className='row justify-content-center align-items-center' style={{ marginBottom: '1rem',marginLeft:"1rem"}}>
          <div className='col-md-4'>

          <img src={imageUrl} alt='GJUlogo' style={{ width: 70, height: 65 }} />
          </div>
          <div className='col-md-8 mt-3'>

          <h1 style={{ color: "black" }}><strong>GJUST</strong></h1>
          </div>
        </div> */}
          <h4 style={{ fontWeight: "600", fontSize: "1.125rem" }} className="row justify-content-center mt-"> Login Your Account</h4>
          <Form className='pt-3'>
            <FormGroup>
              <Label className="mb-2" style={{ color: "grey" }}><strong>Mobile Number</strong></Label>
              <Input
                className={errors.mobileNumber ? 'is-invalid' : ''}
                maxLength="10"
                value={mobileNumber}
                disabled={mobileField}
                type="text"
                placeholder="Enter Mobile Number"
                onChange={event => setMobileNumber(event.target.value)}
              />
              {errors.mobileNumber && <div className='invalid-feedback' style={{ fontSize: "14px" }}>{errors.mobileNumber}</div>}
            </FormGroup>
            {!isOtpSent && (
              <>
                <Button color="primary" onClick={sendOtp}>Send OTP</Button>
                <div className="new-account mt-3" style={{ color: "grey" }}>
                  <p>Don't have an account? <Link to="/instructions" className="text-primary">Register</Link></p>
                </div>
              </>
            )}
            {isOtpSent && (
              <>
                <FormGroup>
                  <Label className='py-2' style={{ color: "grey" }}><strong>Enter OTP</strong></Label>
                  <Input
                    className={errors.otp ? 'is-invalid' : ''}
                    maxLength="6"
                    type='text'
                    value={onetimepassword}
                    onChange={event => setOneTimePassword(event.target.value)}
                    placeholder='Please Enter OTP'
                  />
                  {errors.otp && <div className='invalid-feedback' style={{ fontSize: "14px" }}>{errors.otp}</div>}
                </FormGroup>
                <Button color="success" onClick={verifyOtp}>Login</Button>
                <Button className='mx-3' color="danger" onClick={handleResendOtp} disabled={timer > 0}>
                  Resend OTP {timer > 0 && `(${timer})`}
                </Button>
              </>
            )}
          </Form>
        </div>
      </div>
    </>
  );
};

export default Login;
